// Diccionarios de idioma. Cada uno va en su propio chunk y solo se descarga
// el que se usa (antes iban los cuatro, ~500 kB, en el paquete principal que
// se descarga antes de pintar nada).

const LOADERS = {
  ca: () => import(/* webpackChunkName: "i18n-ca" */ "@/i18n/ca.json"),
  es: () => import(/* webpackChunkName: "i18n-es" */ "@/i18n/es.json"),
  fr: () => import(/* webpackChunkName: "i18n-fr" */ "@/i18n/fr.json"),
  en: () => import(/* webpackChunkName: "i18n-en" */ "@/i18n/en.json"),
};

export const SUPPORTED = Object.keys(LOADERS);

const cache = {};
// El diccionario en pantalla, para traducir fuera de React (lib/api.js).
let active = null;

export const getCachedDict = (lang) => cache[lang] || null;

export const loadDict = async (lang) => {
  if (!cache[lang]) {
    const mod = await LOADERS[lang]();
    cache[lang] = mod.default || mod;
  }
  return cache[lang];
};

export const setActiveDict = (dict) => {
  active = dict;
};

const lookup = (dict, key) => {
  let cur = dict;
  for (const p of key.split(".")) {
    if (cur && typeof cur === "object" && p in cur) cur = cur[p];
    else return null;
  }
  return typeof cur === "string" ? cur : null;
};

// Variables que cuentan algo, por orden de preferencia: si vale exactamente
// 1 y existe «<clave>_one», se usa esa forma («queda 1 día», no «quedan 1
// días»). Solo "1" literal: en castellano 1000 se escribe "1.000".
const COUNT_VARS = ["n", "count", "days", "trips", "max"];

// Resuelve "a.b.c" con interpolación `{name}`.
export const resolve = (dict, key, vars, fallback) => {
  let cur = lookup(dict, key);
  if (cur === null) return fallback || key; // missing key -> use fallback or echo it back
  if (!vars) return cur;
  const c = COUNT_VARS.find((k) => vars[k] !== undefined && vars[k] !== null);
  if (c && String(vars[c]).trim() === "1") cur = lookup(dict, `${key}_one`) ?? cur;
  return cur.replace(/\{(\w+)\}/g, (_, k) => (vars[k] ?? `{${k}}`));
};

export const translateNow = (key, fallback) => resolve(active, key, null, fallback);
